<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Dados cadastrais</h6>
        </d-col>
        <d-col cols="12" lg="8" class="text-right" v-if="sample">
          <sample-buttons :sample="sample"></sample-buttons>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <sample-form ref="sampleForm"/>
            <d-row>
              <d-col cols="12">
                <div class="control__button">
                  <d-button @click="save" class="btn-primary">Salvar</d-button>
                  <loader v-if="loading" :fullPage="false" class="ml-4"/>
                </div>
              </d-col>
            </d-row>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <confirmation-modal
      :cancel="close"
      :confirm="confirmation.deleteMethod"
      :title="confirmation.title"
      :message="confirmation.message"/>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SampleForm from './SampleForm.vue';
import SampleDelete from './SampleDelete';
import SampleButtons from './SampleButtons.vue';
import { _DELETE_SAMPLE_ } from './SampleModel';

export default {
  name: 'sample-page',
  mixins: [SampleDelete],
  props: {
    sample: {
      type: Object,
      default: null,
    },
  },
  components: {
    Loader,
    SampleForm,
    SampleButtons,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      confirmation: {
        title: 'Confirme exclusão de amostra',
        message: 'Tem certeza que deseja excluir essa amostra?',
        deleteMethod: this.deleteRow,
      },
      selectedObject: null,
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.sampleForm.save();
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_SAMPLE_, sampleId => {
      this.confirmation = {
        title: 'Confirme exclusão de amostra',
        message: 'Tem certeza que deseja excluir esse amostra?',
        deleteMethod: this.deleteRow,
      };
      this.selectedObject = sampleId;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
